import { render, staticRenderFns } from "./narratorPage.vue?vue&type=template&id=6c0b3cd6&scoped=true"
import script from "./narratorPage.vue?vue&type=script&lang=js"
export * from "./narratorPage.vue?vue&type=script&lang=js"
import style0 from "./narratorPage.vue?vue&type=style&index=0&id=6c0b3cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b3cd6",
  null
  
)

export default component.exports